module.exports = __webpack_public_path__ + "media/images/entry_ic-4865c09e940312e41f4ddd50ba2f7954.svg";